module.exports = __webpack_public_path__ + "img/thepwatana-guarantee.dca00b19.png";